import styled from 'styled-components';

export const Title = styled.h1`
  color: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin: 0.5rem auto;
`;

export const Relatorio = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.25rem 0.25rem;

  table {
    color: white;

    th {
      padding: 0.5rem 0.25rem;
      width: 5%;
      outline: 1px solid white;
      font-size: 0.7em;

      @media (max-width: 1115px) {
        font-size: 0.5em;
        padding: 0.5rem 0.15rem;
      }

      @media (max-width: 865px) {
        padding: 0.5rem 0.1rem;
        font-size: 0.03em;
      }

      @media (max-width: 755px) {
        padding: 0.5rem 0rem;
      }
    }

    td {
      padding: 0.5rem 0rem;
      outline: 0.5px solid white;
      text-align: center;
      font-size: 0.6em;

      @media (max-width: 1150px) {
        font-size: 0.5em;
      }

      @media (max-width: 755px) {
        font-size: 0.03em;
      }
    }
  }


  button {
    margin: 1rem 0rem;
    width: 25%;
    background-color: white;
    color: black;
  }
`;

export const Lista = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 2rem;
  margin-bottom: 2rem;
  margin-top: 2rem;

  input {
    margin-right: 1rem;
    cursor: pointer;
  }

  label {
    color: white;
    cursor: pointer;
  }
`;
